import { useOrg } from 'contexts/OrgContext'
import useLegalEntity from 'hooks/data/legalEntityHook'
import { useOrgSetting } from 'hooks/data/settingsHooks'

const useIsLegalEntityRootOrg = () => {
  const { org } = useOrg()
  const { rootOrg, isLoadingEntity } = useLegalEntity()
  const { value: isLegalEntitiesEnabled, isLoading: isLoadingOrgSetting } =
    useOrgSetting('enable_legal_entities')

  const isLoading = isLoadingOrgSetting || isLoadingEntity
  const isLegalEntityRootOrg = !isLoading && isLegalEntitiesEnabled && rootOrg === org

  return { isLegalEntityRootOrg, isLoading }
}

export default useIsLegalEntityRootOrg
